export default {
  subsiteCode: 'TR',
  subsiteName: 'Teaching Resources',
  environment: import.meta.env.MODE || 'development',
  version: import.meta.env.VITE_VERSION || 1,
  baseApiUrl: import.meta.env.VITE_GRAPHQL_API_URI || '',
  auth: {
    aTokenKey: import.meta.env.VITE_ADMIN_TOKEN_KEY || 'a-token',
    xTokenKey: import.meta.env.VITE_TOKEN_KEY || 'x-token',
    rTokenKey: import.meta.env.VITE_REFRESH_TOKEN_KEY || 'r-token',
  },
  subsitesUrl: {
    main: import.meta.env.VITE_MAIN_SITE_URL || 'https://main.alearningplace.com.au/',
    slr: import.meta.env.VITE_SLR_SITE_URL || 'https://slr.alearningplace.com.au/',
    tr: import.meta.env.VITE_TR_SITE_URL || 'https://tr.alearningplace.com.au/',
    dvr: import.meta.env.VITE_DVR_SITE_URL || 'https://dvr.alearningplace.com.au/',
    ftd: import.meta.env.VITE_4TD_SITE_URL || 'https://4td.alearningplace.com.au/',
    plr: import.meta.env.VITE_PLR_SITE_URL || 'https://plr.alearningplace.com.au/',
  },
  pageBuilderUrls: {
    main: import.meta.env.VITE_TR_SITE_URL || 'https://alearningplace.com.au',
  },
  //all authenticated user reroutes here as default
  defaultProtectedRoute: '/subscription/create',
  stripe: {
    pk: import.meta.env.VITE_STRIPE_PK,
  },
};
